import { LockOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Alert, Button, Card, Form, Input, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppConfig } from "../../shared/config/AppConfigProvider";
import { authApi } from "./auth-api";
import { useAuth } from "./AuthProvider";

type PasswordValues = { currentPassword: string; newPassword: string; confirmPassword: string };

export function RequiredPasswordChangePage() {
  const { text } = useAppConfig();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm<PasswordValues>();
  const change = useMutation({
    mutationFn:authApi.changePassword,
    onSuccess:()=>{
      message.success(text.passwordChanged);
      logout();
      navigate("/login",{replace:true});
    }
  });
  return <main className="login-page"><section className="login-brand"><div className="brand-mark">AF</div><Typography.Title>AutoFlow Pro</Typography.Title><p>V7 PROFESSIONAL</p><span>{text.appSubtitle}</span></section><Card className="login-card">
    <Typography.Title level={2}>{text.passwordChangeRequired}</Typography.Title>
    <Typography.Paragraph type="secondary">{text.firstLoginPasswordHint}</Typography.Paragraph>
    {change.isError&&<Alert type="error" showIcon message={(change.error as Error).message} style={{marginBottom:16}}/>}
    <Form form={form} layout="vertical" onFinish={values=>change.mutate({currentPassword:values.currentPassword,newPassword:values.newPassword})}>
      <Form.Item name="currentPassword" label={text.temporaryPassword} rules={[{required:true},{min:8}]}><Input.Password prefix={<LockOutlined/>} autoComplete="current-password"/></Form.Item>
      <Form.Item name="newPassword" label={text.newPassword} rules={[{required:true},{min:12},{max:128}]}><Input.Password prefix={<LockOutlined/>} autoComplete="new-password"/></Form.Item>
      <Form.Item name="confirmPassword" label={text.confirmNewPassword} dependencies={["newPassword"]} rules={[{required:true},({getFieldValue})=>({validator:(_,value)=>!value||getFieldValue("newPassword")===value?Promise.resolve():Promise.reject(new Error(text.passwordsDoNotMatch))})]}><Input.Password prefix={<LockOutlined/>} autoComplete="new-password"/></Form.Item>
      <Button type="primary" htmlType="submit" block loading={change.isPending}>{text.changePassword}</Button>
    </Form>
  </Card></main>;
}
